var jade = require("/opt/atlassian/pipelines/agent/build/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div ng-click=\"vm.close()\" class=\"c-analytics-modal c-segment-modal is-open\"><div ng-click=\"$event.stopPropagation()\" class=\"c-filters-widget__dialog c-segment-modal__dialog\"><div class=\"c-segment__body u-pt-\"><segments-edit segment=\"vm.segment\" close=\"vm.close()\" ng-if=\"vm.segment\" enable-previews=\"vm.enablePreviews\"></segments-edit></div></div></div>");;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/segments/segmentsEditModal.jade
 ** module id = 860
 ** module chunks = 0
 **/